var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transload-and-return-to-base',{attrs:{"back":{ name: 'IncidentProcessTransload' }}})
}
var staticRenderFns = []

export { render, staticRenderFns }